/**
 * Utility functions for salary formatting
 */

/**
 * Format number with spaces as thousands separators
 */
export const formatNumberWithSpaces = (value: string): string => {
  const numericValue = value.replace(/\s/g, '').replace(/[^0-9]/g, '')
  if (!numericValue) return ''
  return numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

/**
 * Remove formatting from number string
 */
export const unformatNumber = (value: string): string => {
  return value.replace(/\s/g, '').replace(/[^0-9]/g, '')
}

/**
 * Format salary for display
 */
export const formatSalaryForDisplay = (salary: string): string => {
  if (!salary || salary === '$0') return salary
  const numericValue = salary.replace(/[^0-9]/g, '')
  if (!numericValue) return salary
  const formatted = formatNumberWithSpaces(numericValue)
  return `$${formatted}`
}

/**
 * Format salary from database values
 */
export const formatSalary = (salaryMax: number | null, currency: string | null): string => {
  if (!salaryMax || salaryMax === 0) return '$0'
  const formatted = formatNumberWithSpaces(salaryMax.toString())
  const currencySymbol = currency === 'USD' ? '$' : currency || '$'
  return `${currencySymbol}${formatted}`
}


